<div class="documents-container">
  <div
    class="documents-container__item"
    *ngFor="let doc of resultFiles"
    [ngClass]="{ 'has-file': doc.hasDoc }"
    (click)="downloadDocument(doc)"
  >
    <div class="documents-container__item-status">
      <img *ngIf="doc.hasDoc" src="assets/icons/icon-done-green.svg" />
      <img *ngIf="!doc.hasDoc" src="assets/icons/icon-doc-red.svg" />
    </div>
    <div class="documents-container__item-name-type">
      <div class="documents-container__item-name" *ngIf="!!doc?.fileName">{{ doc.fileName }}</div>
      <div class="documents-container__item-type">{{ "DOCUMENT_TYPE." + enumDocumentType[doc.type] | translate }}</div>
    </div>
  </div>
</div>

<a #link class="d-none" download></a>
